import {Box, Typography} from '@mui/material';
import {ReactComponent as CaretDownIcon} from '../../../../assets/images/caret-base-icon.svg';
import {ReactComponent as TickMarkIcon} from '../../../../assets/images/tick-mark-base-icon.svg';
import './DocListParentFilter.scss';

export type DocListParentFilterData = {
  id: string;
  label: string;
  type: string;
  isSelected: boolean;
};

type DocListParentFilterProps = {
  filterData: DocListParentFilterData;
  onClick: (event: any, param: DocListParentFilterData) => void;
};
const DocListParentFilter: React.FC<DocListParentFilterProps> = ({
  filterData,
  onClick,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    // Handle both Enter and Space keys
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e, filterData);
    }
  };

  return (
    <Box
      aria-label={filterData.label}
      data-testid={`DocListParentFilter-${filterData.id}`}
      className={`doc-list-parentFilter ${filterData.isSelected ? 'selected-state' : 'non-selected-state'}`}
      tabIndex={0}
      role="button"
      aria-pressed={filterData.isSelected}
      onClick={(e) => onClick(e, filterData)}
      onKeyDown={handleKeyDown}
    >
      <Box
        className="items-alignment"
        data-testid={`doc-list-items-alignment-box-${filterData.id}`}
      >
        <Typography
          className="typo-text label3_size filter-label"
          data-testid={`doc-list-parent-filter-typography-${filterData.id}`}
        >
          {filterData.label}
        </Typography>
        {filterData.isSelected ? (
          <TickMarkIcon className="tick-mark-icon" aria-hidden="true" />
        ) : (
          <CaretDownIcon className="caret-down-icon" aria-hidden="true" />
        )}
      </Box>
    </Box>
  );
};

export default DocListParentFilter;
